import { SchedulesExportFRM103ResType } from "../../../../../models/list/export"
import { exportExcelFRM103 } from "./excel"

export const exportFRM103 = (dataSource: SchedulesExportFRM103ResType[]) => {
  exportExcelFRM103(dataSource)
}
